import "jquery.easing";

class ScrollToTop {
  constructor() {
    this.element = document.querySelector("#scrollTop");

    this.element.addEventListener("click", this.scrollToTop.bind(this));
  }

  init() {
    window.addEventListener("scroll", this.toggle.bind(this));
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  toggle() {
    if (window.scrollY > 100) {
      this.element.classList.add("show");
    } else {
      this.element.classList.remove("show");
    }
  }
}

export default ScrollToTop;
